import type { IconSvgProps } from '../Icon.types';

export const ExclamationFilled = ({ fill, width, height, className }: IconSvgProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 9.5C7.86739 9.5 7.74021 9.46049 7.63888 9.38388C7.53754 9.30727 7.47086 9.19806 7.45096 9.0777L7 5.5C7 5.36739 7.05268 5.24021 7.14645 5.14645C7.24021 5.05268 7.36739 5 7.5 5H8.5C8.63261 5 8.75979 5.05268 8.85355 5.14645C8.94732 5.24021 9 5.36739 9 5.5L8.54904 9.0777C8.52914 9.19806 8.46246 9.30727 8.36112 9.38388C8.25979 9.46049 8.13261 9.5 8 9.5ZM8.75 11.5C8.75 11.6989 8.67098 11.8897 8.53033 12.0303C8.38968 12.171 8.19891 12.25 8 12.25C7.80109 12.25 7.61032 12.171 7.46967 12.0303C7.32902 11.8897 7.25 11.6989 7.25 11.5C7.25 11.3011 7.32902 11.1103 7.46967 10.9697C7.61032 10.829 7.80109 10.75 8 10.75C8.19891 10.75 8.38968 10.829 8.53033 10.9697C8.67098 11.1103 8.75 11.3011 8.75 11.5Z"
      fill={fill}
    />
  </svg>
);
